/*
  "Klienci kupowali również" przy karcie produktu.

  Propozycje z rekomendacji Shopify. Pokazujemy po jednej naraz, ze strzalkami -
  tak jak na masmi. Dodanie do koszyka idzie przez /cart/add.js, wiec nie
  przeladowujemy strony.
*/
(function () {
  'use strict';

  function pieniadze(grosze) {
    return (grosze / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function miniatura(url, px) {
    if (!url) return '';
    return url.indexOf('?') > -1 ? url + '&width=' + px : url + '?width=' + px;
  }

  function start() {
    var korzen = document.querySelector('[data-ciroa-obok]');
    if (!korzen || korzen.dataset.gotowe) return;
    korzen.dataset.gotowe = '1';

    var lista = korzen.querySelector('[data-lista]');
    var id = korzen.dataset.produkt;
    var pozycja = 0;
    var produkty = [];

    /* `intent=complementary` wymaga skonfigurowania aplikacji Search & Discovery
       i bez niej zwraca pusta liste. Probujemy go pierwszy, bo daje trafniejsze
       propozycje, a gdy nic nie wroci - bierzemy zwykle rekomendacje. */
    function pobierz(intencja) {
      var adres = '/recommendations/products.json?product_id=' + id + '&limit=6'
        + (intencja ? '&intent=' + intencja : '');
      return fetch(adres)
        .then(function (o) { return o.ok ? o.json() : { products: [] }; })
        .then(function (d) {
          return (d.products || []).filter(function (p) { return p.available; });
        })
        .catch(function () { return []; });
    }

    pobierz('complementary')
      .then(function (lista) { return lista.length ? lista : pobierz('related'); })
      .then(function (lista) {
        produkty = lista;
        if (!produkty.length) return;
        rysuj();
        korzen.hidden = false;
      });

    function rysuj() {
      var p = produkty[pozycja];
      var w = p.variants[0];
      lista.innerHTML = '';
      var li = document.createElement('li');
      li.className = 'ciroa-obok__pozycja';
      li.innerHTML =
        '<a class="ciroa-obok__zdjecie" href="' + p.url + '">' +
          '<img src="' + miniatura(p.featured_image, 220) + '" alt="" loading="lazy" width="110" height="138">' +
        '</a>' +
        '<div class="ciroa-obok__dane">' +
          '<a class="ciroa-obok__nazwa" href="' + p.url + '"></a>' +
          '<p class="ciroa-obok__cena">' + pieniadze(p.price) + '</p>' +
          '<button type="button" class="button button--secondary ciroa-obok__dodaj">Dodaj</button>' +
        '</div>';
      li.querySelector('.ciroa-obok__nazwa').textContent = p.title;
      lista.appendChild(li);

      li.querySelector('.ciroa-obok__dodaj').addEventListener('click', function (e) {
        var przycisk = e.currentTarget;
        przycisk.disabled = true;
        przycisk.textContent = 'Dodaję...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: w.id, quantity: 1 })
        }).then(function (o) {
          przycisk.textContent = o.ok ? 'W koszyku' : 'Spróbuj ponownie';
          if (o.ok) document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () { przycisk.disabled = false; przycisk.textContent = 'Dodaj'; }, 2200);
        });
      });
      odswiezStrzalki();
    }

    function odswiezStrzalki() {
      korzen.querySelector('[data-wstecz]').disabled = produkty.length < 2;
      korzen.querySelector('[data-dalej]').disabled = produkty.length < 2;
    }

    korzen.querySelector('[data-wstecz]').addEventListener('click', function () {
      pozycja = (pozycja - 1 + produkty.length) % produkty.length; rysuj();
    });
    korzen.querySelector('[data-dalej]').addEventListener('click', function () {
      pozycja = (pozycja + 1) % produkty.length; rysuj();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else { start(); }
})();
